import { render, staticRenderFns } from "./LpuCardsFiltersToggleItem.vue?vue&type=template&id=064119e6&scoped=true&"
import script from "./LpuCardsFiltersToggleItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LpuCardsFiltersToggleItem.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LpuCardsFiltersToggleItem.vue?vue&type=style&index=0&id=064119e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064119e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064119e6')) {
      api.createRecord('064119e6', component.options)
    } else {
      api.reload('064119e6', component.options)
    }
    module.hot.accept("./LpuCardsFiltersToggleItem.vue?vue&type=template&id=064119e6&scoped=true&", function () {
      api.rerender('064119e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/diagnostika/analiz/components/LpuCard/LpuCardsFiltersToggleItem.vue"
export default component.exports